import { render, staticRenderFns } from "./headConfig.vue?vue&type=template&id=535bc313&scoped=true"
import script from "./headConfig.vue?vue&type=script&lang=js"
export * from "./headConfig.vue?vue&type=script&lang=js"
import style0 from "./headConfig.vue?vue&type=style&index=0&id=535bc313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535bc313",
  null
  
)

export default component.exports